export default "__VITE_ASSET__BEFFWTbR__"